<template>
	<div v-if="get_url">
		<k-video-player :url="get_url" load-player></k-video-player>
	</div>
</template>

<script>
import EventModel from '@/models/event.js'

export default {
	props: ["uuid"],
	components: {
	},
	data () {
		var ch = this.$cloudserver.channel("events:"+this.uuid);
		return {
			ws_channel: ch,
			event: ch.data
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				console.log("NEW VAL");
				this.event = newVal;
			},
			deep: true
		}
	},
	computed: {
		get_url() {
			return EventModel.live_url(this.event);

		}
	},
	created () {
		this.ws_channel.join();
	}
}
</script>